import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { OfferActions, OfferActionTypes } from '../actions/offer.actions';
import { OfferBucketLoad } from '../models/offer-bucket.model';

export interface OfferState {
  openBuckets: OfferBucketLoad[];
}

export const initialState: OfferState = {
  openBuckets: [],
};

const upsertBucket = (buckets: OfferBucketLoad[], payload: OfferBucketLoad) => {
  const index = buckets.findIndex(bucket => bucket.load.loadNumber === payload.load.loadNumber);
  return index < 0
    ? [...buckets, payload]
    : buckets.map(bucket => {
        if (bucket.load.loadNumber === payload.load.loadNumber) {
          return payload;
        } else {
          return bucket;
        }
      });
};

export function offerReducer(state = initialState, action: OfferActions | OrderBuilderActions): OfferState {
  switch (action.type) {
    case OfferActionTypes.OPEN_BUCKET: {
      return {
        ...state,
        openBuckets: upsertBucket(state.openBuckets, action.payload),
      } as OfferState;
    }
    case RESET_BUILDER:
    case OfferActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
